import { useTranslation } from "react-i18next";
import Footer from "../Component/Dynamic/Footer";
import { useState, useEffect } from "react";
import { AddNewRecord } from "../Funcs/Add";
import { firestore, myFbHomecarevisits } from "../Utils/fbFunctionInit";
import {
  Form,
  Button,
  Col,
  Row,
  Container,
  Stack,
  Modal,
} from "react-bootstrap";
import { BasicColor } from "../Utils/constants";
import { toEnglishNumber } from "../Funcs/Miscellaneous";
import DateModal from "./Dynamic/MyDatePickerModal";
import { CalindarIcon, WhatsappIcon, PhoneIcon } from "../Utils/SVGs";
import {
  districts,
  YOUR_GOOGLE_MAPS_API_KEY,
} from "../Utils/constantsHomeCare";
import LocationButton from "../Component/Dynamic/LocationButton";

function RegHome() {
  const { t, i18n } = useTranslation();
  const [name, setName] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [date_of_birth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("");
  const [district, setDistrict] = useState(districts[0]);
  const [home_address, setHomeAddress] = useState("");
  const [location, setLocation] = useState(null);
  const [locationStr, setLocationStr] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedServicesStr, setSelectedServicesStr] = useState(
    t("HomeVisit")
  );
  const [showLoading, setShowLoading] = useState(false);
  const [currentPt, setCurrentPt] = useState(null);
  const [homeOrClinic, setHomeOrClinic] = useState("Home");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    console.log(
      "current patient from local storage",
      localStorage.getItem("currentPt")
    );
    if (localStorage.getItem("currentPt")) {
      const pt = JSON.parse(localStorage.getItem("currentPt"));
      setName(pt.Name);
      setPhoneNumber(pt.Phone);
      setGender(pt.Gender);
    }
  }, []);

  const isEgyptianPhoneNumber = (phoneNumber) => {
    // Check if the phone number starts with the Egypt dial code
    if (phoneNumber.startsWith("+20") && phoneNumber.length >= 11) {
      return phoneNumber;
    } else {
      // The phone number does not start with the Egypt dial code, so add it
      if (phoneNumber.length >= 11) {
        setPhoneNumber("+2" + phoneNumber);
        return "+2" + phoneNumber;
      } else {
        return false;
      }
    }
  };

  const handleScheduleHomeVisit = async () => {
    // ...add these to the string when you need...

    // \n${t("Address")}: ${home_address}

    const message = `${t("Name")}: ${name}\n${t("DOB")}: ${date_of_birth}\n${t(
      "Gender"
    )}: ${gender}\n${t("Phone")} : ${phone_number}\n${t(
      "Appointment"
    )}: ${selectedDate}\n${t("SelectedServices")}:${selectedServicesStr}\n${t(
      "Address"
    )}: ${home_address}\n${t("District")}: ${district}\n\n${t(
      "Location"
    )}: ${locationStr}`;

    const url = `https://wa.me/+201110115999?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_self");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Validate phone number

    const validPhoneNumber = isEgyptianPhoneNumber(phone_number);
    if (!validPhoneNumber) {
      // Phone number is not valid
      alert(t("InvalidPhoneNumber"));
      return;
    } else {
      setShowLoading(true);
      const patient = {
        Name: name,
        Phone: validPhoneNumber,
        DOB: date_of_birth,
        Gender: gender,
        Address: home_address,
        District: district,
        Date: new Date().toISOString().slice(0, 10),
        Time: new Date().toTimeString().slice(0, 8),
      };
      let resultMsg = await AddNewRecord(
        patient,
        phone_number,
        myFbHomecarevisits,
        t
      );
      if (
        resultMsg === t("RecordSuccessfullyUpdated") ||
        resultMsg === t("RecordSuccessfullyAdded")
        // ||
        // resultMsg === t("RecordNotUpdated")
      ) {
        setCurrentPt(patient);
      } else {
        setCurrentPt(null);
      }
      if (resultMsg) {
        // scroll to top
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        // then
        setShowLoading(false);
        const currentPt = JSON.stringify(patient);
        localStorage.setItem("currentPt", currentPt);
        console.log("currPt", currentPt);
      }
      alert(resultMsg);
    }
    // TODO: Submit form data to backend
  };
  const handleOpenDateModal = () => {
    setShowModal(true);
  };
  const handleCloseDateModal = () => {
    setShowModal(false);
  };

  const handleSelectDate = (date) => {
    setSelectedDate(date);
    let tempPt = { ...currentPt, Appointment: date };
    setCurrentPt(tempPt);
    setShowModal(false);
  };

  const handleLocationRetrieved = ({ latitude, longitude }) => {
    console.log("Location received:", latitude, longitude);
    setLocation({ latitude, longitude });
    // You can use the location data as needed here
    setLocationStr(`https://www.google.com/maps?q=${latitude},${longitude}`);
  };

  return (
    <Container style={{ marginBottom: "10px" }}>
      <h1 style={{ margin: "10px", color: BasicColor }}>
        {t(`${homeOrClinic}VisitRegistration`)}
      </h1>
      <Row>
        <Col md={6}>
          <h2>{t("Register")}</h2>
          <Form onSubmit={handleSubmit}>
            {currentPt ? (
              <></>
            ) : (
              <div>
                <Form.Group controlId="name">
                  <Stack direction="horizontal" gap={1}>
                    <Form.Label>{t("Name")}</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                      required
                    />
                  </Stack>
                </Form.Group>
                <Form.Group controlId="phone_number">
                  <Stack direction="horizontal" gap={1}>
                    <Form.Label>{t("Phone")}</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone_number"
                      value={toEnglishNumber(phone_number)}
                      onChange={(event) =>
                        setPhoneNumber(toEnglishNumber(event.target.value))
                      }
                      required
                      dir="ltr"
                    />
                  </Stack>
                </Form.Group>

                <Form.Group controlId="gender">
                  <Stack direction="horizontal" gap={1}>
                    <Form.Label>{t("GenderHome")}</Form.Label>
                    <Form.Control
                      as="select"
                      name="gender"
                      value={gender}
                      required
                      onChange={(event) => setGender(event.target.value)}
                      style={{ textAlign: "center", textAlignLast: "center" }}
                    >
                      <option value="Male">{t("MaleHome")}</option>
                      <option value="Female">{t("FemaleHome")}</option>
                    </Form.Control>
                  </Stack>
                </Form.Group>

                <Form.Group controlId="districts">
                  <Stack direction="horizontal" gap={1}>
                    <Form.Label>{t("District")}</Form.Label>
                    <Form.Control
                      as="select"
                      name="district"
                      value={district}
                      onChange={(event) => setDistrict(event.target.value)}
                      style={{ textAlign: "center", textAlignLast: "center" }}
                    >
                      {districts.map((aDistrict) => (
                        <option key={aDistrict} value={aDistrict}>
                          {t(aDistrict)}
                        </option>
                      ))}
                    </Form.Control>
                  </Stack>
                </Form.Group>

                <Form.Group controlId="home_address">
                  <Stack direction="horizontal" gap={1}>
                    <Form.Label>{t("Address")}</Form.Label>
                    <Form.Control
                      type="text"
                      name="home_address"
                      value={home_address}
                      onChange={(event) => setHomeAddress(event.target.value)}
                    />
                    <LocationButton
                      send={false}
                      onLocationRetrieved={handleLocationRetrieved}
                    />
                  </Stack>
                  {location && (
                    <iframe
                      title="User Location"
                      width="100%"
                      height="400px"
                      style={{ border: 0, marginTop: "20px" }}
                      loading="lazy"
                      allowFullScreen
                      src={`https://www.google.com/maps/embed/v1/place?key=${YOUR_GOOGLE_MAPS_API_KEY}&q=${location.latitude},${location.longitude}&zoom=15`}
                    ></iframe>
                  )}
                </Form.Group>
                <Button
                  type="submit"
                  style={{ margin: "3%", backgroundColor: BasicColor }}
                >
                  {"1) "}
                  {t("Register")}
                </Button>
              </div>
            )}
          </Form>
          {window.innerWidth >= 768 && currentPt ? (
            <div>
              {" "}
              <div>
                <img src="/imgs/homeCareImage.jpg" style={{ width: "50%" }} />
              </div>
              <Button
                variant="danger"
                style={{ color: "white", fontStyle: "italic" }}
                onClick={() => window.location.reload()}
              >
                {t("RefreshPageToRegister")}
              </Button>
            </div>
          ) : (
            <></>
          )}
        </Col>
        <Col md={4}>
          <br />

          {currentPt && (
            <div
              style={{
                borderColor: BasicColor,
                borderStyle: "solid",
                borderRadius: "15px",
                backgroundColor: "lightblue",
              }}
            >
              {currentPt && (
                <div>
                  <br />
                  <h2>{t(`BookAHomeVisit${homeOrClinic}`)}</h2>
                  <Button
                    onClick={handleOpenDateModal}
                    disabled={currentPt ? false : true}
                    style={{ margin: "10px", backgroundColor: BasicColor }}
                    variant={selectedDate ? "outline-primary" : "primary"}
                  >
                    {!selectedDate
                      ? t("SelectDate2")
                      : CalindarIcon("white", 16)}
                  </Button>
                  {/* <br />
                  <br /> */}
                  <p>
                    {selectedDate && t("SelectedDate")} {selectedDate}
                  </p>
                  {selectedDate && (
                    <div>
                      <hr />
                      <p style={{ fontWeight: "bold", marginBottom: "0px" }}>
                        {t("SelectedServices")}:
                      </p>
                      {t("HomeVisit")}: {500} {t("EGP")}
                      <p>
                        {t("TotalPrice")}: {500} {t("EGP")}
                      </p>
                      {
                        <Button
                          onClick={handleScheduleHomeVisit}
                          disabled={selectedDate ? false : true}
                          variant="success"
                          style={{ margin: "10px", fontWeight: "bold" }}
                        >
                          {WhatsappIcon("white", 20)}
                          {" : "}

                          {t("Finish")}
                        </Button>
                      }
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          <br />
          <Button
            variant="danger"
            style={{
              width: "50%",
              margin: "10px",
              fontWeight: "bold",
            }}
            onClick={() => {
              const telHref = `tel:${"+201110115999"}`;
              window.location.href = telHref;
            }}
          >
            {"  "}
            {PhoneIcon("white", 20)}
            {" : "}
            {t("CallNow")}
          </Button>

          <br />
          <br />
          <div>
            {showModal && (
              <DateModal
                onClose={handleCloseDateModal}
                onSelectDate={handleSelectDate}
              />
            )}
          </div>

          {window.innerWidth < 768 && currentPt ? (
            <div>
              {" "}
              <div>
                <img src="/imgs/homeCareImage.jpg" style={{ width: "50%" }} />
              </div>
              <Button
                variant="danger"
                style={{ color: "white", fontStyle: "italic" }}
                onClick={() => window.location.reload()}
              >
                {t("RefreshPageToRegister")}
              </Button>
            </div>
          ) : (
            <></>
          )}
        </Col>
      </Row>
      <Modal show={showLoading}>
        <h3 style={{ margin: "10px" }}>{t("Resgistering")}</h3>
      </Modal>
      <hr />
      <br />
    </Container>
  );
}

export default RegHome;
